<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app>
      <v-list>
        <v-list-item
          title="WikiBase"
          subtitle="Корпоративная база знаний"
        ></v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list density="compact" nav>
        <!-- Основные -->
        <v-list-item
          link
          prepend-icon="mdi-chat-processing"
          title="Мессенджер (Beta)"
          value="messenger"
          @click="go('/messenger')"
        ></v-list-item>
        <v-list-item
          link
          prepend-icon="mdi-message-text-outline"
          title="Диалоги (БД)"
          value="analyticsDialogs"
          @click="go('/analytics-dialogs')"
        ></v-list-item>
        <v-list-item
          link
          prepend-icon="mdi-account-group-outline"
          title="CRM контакты"
          value="contacts"
          @click="go('/contacts')"
        ></v-list-item>
        <v-list-item
          link
          prepend-icon="mdi-chart-timeline-variant"
          title="Клиенты МедиаНации"
          value="mnClientInvoices"
          @click="go('/mn-client-invoices')"
        ></v-list-item>

        <v-list-item
          link
          prepend-icon="mdi-account-multiple"
          title="Наши telegram аккаунты"
          value="telethon"
          @click="go('/telethon')"
        ></v-list-item>
        <v-list-item
          link
          prepend-icon="mdi-bullseye-arrow"
          title="Outreach Hub"
          value="custDevTv"
          @click="go('/custdev-tv')"
        ></v-list-item>
        <v-list-item
          link
          prepend-icon="mdi-file-document-outline"
          title="KP (каталог/отчёт)"
          value="kp"
          @click="go('/kp')"
        ></v-list-item>
        <v-list-item
          v-if="shareholdersReportAccess"
          link
          prepend-icon="mdi-finance"
          title="Отчёт акционерам (P&amp;L)"
          value="shareholdersReport"
          @click="go('/shareholders-report')"
        ></v-list-item>
        <v-list-item
          v-if="shareholdersReportAccess || commercialPnlAccess"
          link
          prepend-icon="mdi-chart-timeline-variant"
          title="P&amp;L коммблока"
          value="commercialPnl"
          @click="go('/commercial-pnl')"
        ></v-list-item>
        <v-list-item
          link
          prepend-icon="mdi-book-open-variant"
          title="Finance Wiki (FAQ)"
          value="financeWiki"
          @click="go('/finance-wiki')"
        ></v-list-item>
        <v-list-item
          link
          prepend-icon="mdi-notebook-outline"
          title="Вики"
          value="wiki"
          @click="go('/wiki')"
        ></v-list-item>
        <v-divider class="my-2"></v-divider>

        <!-- Всё остальное прячем в "В разработке" -->
        <v-list-group prepend-icon="mdi-hammer-wrench" value="dev-group">
          <template #activator="{ props }">
            <v-list-item v-bind="props" title="🚧 В разработке"></v-list-item>
          </template>
          <!-- Рабочие функции (скрыты) -->
          <v-list-item
            link
            prepend-icon="mdi-home"
            title="Главная"
            value="home"
            @click="go('/')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-forum"
            title="Каналы/Чаты"
            value="chats"
            @click="go('/chats')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-bullhorn-outline"
            title="CRM Outreach (планировщик)"
            value="crm-outreach"
            @click="go('/crm-outreach')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-clipboard-check-outline"
            title="Задачи (План на день)"
            value="tasks"
            @click="go('/tasks')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-view-dashboard-outline"
            title="Таск-борд (люди и агенты)"
            value="taskBoard"
            @click="go('/task-board')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-chart-box-outline"
            title="Analytics"
            value="analytics"
            @click="go('/analytics')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-calendar-range"
            title="Отчёты по дням"
            value="dailyReports"
            @click="go('/daily-reports')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-chart-line"
            title="📊 Analytics Dashboard"
            value="analyticsDashboard"
            @click="go('/analytics-dashboard')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-robot-clock"
            title="🤖 Автоматическая аналитика"
            value="analyticsAutoJobs"
            @click="go('/analytics-auto-jobs')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-format-list-bulleted"
            title="🧾 LLM Logs"
            value="llm-logs"
            @click="go('/llm-logs')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-flask-outline"
            title="🧪 LLM Evals"
            value="llm-evals"
            @click="go('/llm-evals')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-lightbulb-on"
            title="💡 AI-суфлёр (Черновики)"
            value="drafts"
            @click="go({ path: '/tasks', query: { view: 'drafts' } })"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-calendar-clock"
            title="Встречи и календарь"
            value="manager-settings-main"
            @click="go('/manager-settings')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-robot-outline"
            title="🤖 AI Боты"
            value="ai-bots"
            @click="go('/ai-bots')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-account-tie-outline"
            title="👤 AI-сотрудники"
            value="ai-staff"
            @click="go('/ai-staff')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-email-outline"
            title="✉️ Почтовые аккаунты"
            value="email-accounts"
            @click="go('/email-accounts')"
            class="nested-menu-item"
          ></v-list-item>
          <v-divider class="my-2"></v-divider>

          <v-list-group prepend-icon="mdi-cog" value="settings-group" sub-group>
            <template #activator="{ props }">
              <v-list-item v-bind="props" title="Настройки"></v-list-item>
            </template>
            <v-list-item
              v-if="isSalesManager"
              link
              prepend-icon="mdi-account-tie"
              title="Менеджер по продажам"
              value="manager-settings"
              @click="go('/manager-settings')"
              class="nested-menu-item"
            ></v-list-item>
          </v-list-group>

          <v-list-group
            prepend-icon="mdi-shield-crown"
            value="admin-group"
            sub-group
          >
            <template #activator="{ props }">
              <v-list-item v-bind="props" title="👑 Администрирование"></v-list-item>
            </template>
            <v-list-item
              link
              prepend-icon="mdi-account-group"
              title="Пользователи"
              value="users"
              @click="go('/users')"
              class="nested-menu-item"
            ></v-list-item>
            <v-list-item
              link
              prepend-icon="mdi-cog"
              title="Настройки системы"
              value="system-settings"
              @click="go('/system-settings')"
              class="nested-menu-item"
            ></v-list-item>
            <v-list-item
              link
              prepend-icon="mdi-shield-lock"
              title="Управление прокси"
              value="proxy-management"
              @click="go('/proxy-management')"
              class="nested-menu-item"
            ></v-list-item>
            <v-list-item
              link
              prepend-icon="mdi-link-variant"
              title="Назначение прокси"
              value="proxy-assignment"
              @click="go('/proxy-assignment')"
              class="nested-menu-item"
            ></v-list-item>
            <v-list-item
              link
              prepend-icon="mdi-chart-timeline-variant"
              title="Telethon Events"
              value="telethon-events"
              @click="go('/telethon-events')"
              class="nested-menu-item"
            ></v-list-item>
            <v-list-item
              link
              prepend-icon="mdi-link-variant"
              title="CRM Aggregation Rules"
              value="crm-aggregation-rules"
              @click="go('/crm-aggregation-rules')"
              class="nested-menu-item"
            ></v-list-item>
            <v-list-item
              link
              prepend-icon="mdi-web-sync"
              title="Domain Review"
              value="company-domain-reviews"
              @click="go('/company-domain-reviews')"
              class="nested-menu-item"
            ></v-list-item>
          </v-list-group>

          <v-divider class="my-2"></v-divider>

          <v-list-item
            link
            prepend-icon="mdi-note-text"
            title="Заметки"
            value="notes"
            @click="go('/notes')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-tag"
            title="Теги"
            value="tags"
            @click="go('/tags')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-telegram"
            title="Telegram"
            value="telegram"
            @click="go('/telegram')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-robot"
            title="LLM Ассистент"
            value="llm"
            @click="go('/llm')"
            class="nested-menu-item"
          ></v-list-item>
          <v-list-item
            link
            prepend-icon="mdi-account"
            title="Профиль"
            value="settings"
            @click="go('/settings')"
            class="nested-menu-item"
          ></v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>WikiBase</v-toolbar-title>
      
      <!-- Переключатель тенантов -->
      <div v-if="tenantStore.availableTenants.length > 0" class="d-flex align-center ml-4">
        <!-- Dropdown для переключения (если несколько тенантов) -->
        <v-menu v-if="tenantStore.hasMultipleTenants" offset-y>
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              variant="text"
              prepend-icon="mdi-office-building"
            >
              <span class="text-truncate" style="max-width: 200px;">
                {{ tenantStore.currentTenantName }}
              </span>
              <v-icon end>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list min-width="250">
            <v-list-subheader>Мои организации</v-list-subheader>
            <v-list-item
              v-for="tenant in tenantStore.availableTenants"
              :key="tenant.id"
              :active="tenant.tenant_id === tenantStore.currentTenant?.tenant_id"
              @click="switchToTenant(tenant.tenant_id)"
            >
              <template v-slot:prepend>
                <v-icon :color="tenant.is_default ? 'primary' : undefined">
                  {{ tenant.is_default ? 'mdi-check-circle' : 'mdi-office-building-outline' }}
                </v-icon>
              </template>
              <v-list-item-title>{{ tenant.tenant_name }}</v-list-item-title>
              <v-list-item-subtitle>{{ getRoleDisplay(tenant.role) }}</v-list-item-subtitle>
            </v-list-item>
            
            <v-divider></v-divider>
            
            <v-list-item link prepend-icon="mdi-plus-circle-outline" @click="go('/create-tenant')">
              <v-list-item-title>Создать организацию</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        
        <!-- Просто название (если один тенант) -->
        <v-btn
          v-else
          variant="text"
          prepend-icon="mdi-office-building"
          disabled
        >
          <span class="text-truncate" style="max-width: 200px;">
            {{ tenantStore.currentTenantName }}
          </span>
        </v-btn>
        
        <!-- Кнопка создания тенанта (всегда видна) -->
        <v-btn
          icon
          size="small"
          variant="text"
          @click="go('/create-tenant')"
          title="Создать новую организацию"
        >
          <v-icon>mdi-plus-circle-outline</v-icon>
        </v-btn>
      </div>
      
      <v-spacer></v-spacer>
      
      <v-btn icon @click="toggleTheme">
        <v-icon>mdi-theme-light-dark</v-icon>
      </v-btn>
      
      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn icon v-bind="props">
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="logout">
            <v-list-item-title>Выйти</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <v-alert
          v-if="llmBillingStatus?.is_blocked"
          type="error"
          variant="tonal"
          density="compact"
          class="mb-2"
          border="start"
        >
          <div class="d-flex align-center">
            <div class="text-truncate">
              <strong>⛔ OpenRouter: кредиты закончились.</strong>
              <span v-if="llmBillingShortageText"> {{ llmBillingShortageText }}</span>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              size="small"
              variant="outlined"
              color="error"
              class="ml-3"
              @click="router.push('/settings')"
            >
              В настройки
            </v-btn>
          </div>
        </v-alert>

        <v-alert
          v-else-if="openrouterBalanceText"
          :type="openrouterBalanceIsZero ? 'error' : 'info'"
          variant="tonal"
          density="compact"
          class="mb-2"
          border="start"
        >
          <div class="d-flex align-center">
            <div class="text-truncate">
              <strong v-if="openrouterBalanceIsZero">⛔ OpenRouter: кредиты закончились (balance=0).</strong>
              <strong v-else>{{ openrouterBalanceText }}</strong>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              size="small"
              variant="outlined"
              :color="openrouterBalanceIsZero ? 'error' : 'info'"
              class="ml-3"
              @click="router.push('/settings')"
            >
              Детали
            </v-btn>
          </div>
        </v-alert>

        <v-alert
          v-if="materializeBlockedCount > 0"
          type="warning"
          variant="tonal"
          density="compact"
          class="mb-2"
          border="start"
        >
          <div class="d-flex align-center">
            <div class="text-truncate">
              <strong>🛑 Materialize: заблокированные задачи.</strong>
              <span> {{ materializeBlockedCount }} шт — нужно “я починил / вернуть в очередь”.</span>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              size="small"
              variant="outlined"
              color="warning"
              class="ml-3"
              @click="router.push('/settings')"
            >
              В настройки
            </v-btn>
          </div>
        </v-alert>

        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, computed, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useApiStore } from '@/stores/api'
import { useTenantStore } from '@/stores/tenant'
import { useMessengerWebSocket } from '@/composables/useMessengerWebSocket'

const drawer = ref(localStorage.getItem('wb_drawer') !== '0')
watch(drawer, (v) => { localStorage.setItem('wb_drawer', v ? '1' : '0') })
const router = useRouter()
const api = useApiStore()
const tenantStore = useTenantStore()
const messengerWs = useMessengerWebSocket()
const isSalesManager = ref(false)
const isAdmin = ref(false)
const switching = ref(false)
const shareholdersReportAccess = ref(false)
const commercialPnlAccess = ref(false)

const go = async (to: any) => {
  try {
    await router.push(to)
  } catch (e) {
    // ignore navigation errors (e.g., navigating to the same route)
  }
}

const llmBillingStatus = ref<any | null>(null)
const openrouterBalance = ref<any | null>(null)
const llmBillingShortageText = computed(() => {
  const s = llmBillingStatus.value
  if (!s?.is_blocked) return ''
  const req = Number(s?.requested_up_to_tokens ?? s?.requested_max_tokens ?? 0)
  const afford = Number(s?.can_afford_tokens ?? 0)
  if (!req || !afford) return ''
  const diff = req - afford
  if (!Number.isFinite(diff) || diff <= 0) return ''
  return `(не хватило ~${diff} токенов)`
})

const openrouterBalanceText = computed(() => {
  const b = openrouterBalance.value
  if (!b?.ok) return ''
  const rem = b?.limit_remaining
  if (rem === null || rem === undefined || rem === '') return ''
  return `OpenRouter: осталось ${rem}`
})

const openrouterBalanceIsZero = computed(() => {
  const b = openrouterBalance.value
  if (!b?.ok) return false
  const rem = Number(b?.limit_remaining)
  return Number.isFinite(rem) && rem === 0
})

const materializeBlockedCount = ref(0)
let materializePollIntervalId: number | null = null

const loadMaterializeBlockedCount = async () => {
  try {
    const resp = await api.getMaterializeBlocked({ limit: 1 })
    const cnt = Number(resp?.count ?? 0)
    materializeBlockedCount.value = Number.isFinite(cnt) ? cnt : 0
  } catch {
    // Best-effort: do not break UI if endpoint is down
  }
}

const toggleTheme = () => {
  // TODO: Реализовать переключение темы
}

const logout = () => {
  localStorage.removeItem('token')
  tenantStore.clearStore()
  router.push('/login')
}

/**
 * Переключиться на другой тенант
 */
const switchToTenant = async (tenantId: number) => {
  if (switching.value) return
  if (tenantId === tenantStore.currentTenant?.tenant_id) return
  
  switching.value = true
  try {
    await tenantStore.switchTenant(tenantId)
    // Перезагружаем страницу для обновления всех данных
    window.location.reload()
  } catch (error: any) {
    console.error('Error switching tenant:', error)
    alert(error.message || 'Ошибка переключения организации')
  } finally {
    switching.value = false
  }
}

/**
 * Отображение роли на русском
 */
const getRoleDisplay = (role: string): string => {
  const roles: Record<string, string> = {
    'platform_admin': 'Супер-администратор',
    'tenant_admin': 'Администратор',
    'sales_manager': 'Менеджер по продажам',
    'user': 'Пользователь'
  }
  return roles[role] || role
}

const checkUserRole = async () => {
  try {
    const settings = await api.getManagerSettings()
    isSalesManager.value = settings.is_sales_manager || false
    
    // Проверяем роль через tenant store
    isAdmin.value = tenantStore.isAdmin
  } catch (error) {
    // Если ошибка (например, пользователь не залогинен), просто не показываем пункты
    isSalesManager.value = false
    isAdmin.value = false
  }
}

onMounted(async () => {
  // Проверяем роли пользователя только если залогинен
  const token = localStorage.getItem('token')
  if (token) {
    // Инициализируем tenant store
    await tenantStore.initStore()
    await checkUserRole()

    try {
      const sh = await api.getShareholdersAccess()
      shareholdersReportAccess.value = Boolean(sh?.allowed)
    } catch {
      shareholdersReportAccess.value = false
    }
    try {
      const cp = await api.getCommercialPnlAccess()
      // тот же allowlist, что у shareholders; если access упал — не прячем пункт
      commercialPnlAccess.value = Boolean(cp?.allowed) || shareholdersReportAccess.value
    } catch {
      commercialPnlAccess.value = shareholdersReportAccess.value
    }

    // Best-effort: загрузка billing статуса + подписка на WS события
    try {
      llmBillingStatus.value = await api.getLlmBillingStatus('openrouter')
    } catch {}
    try {
      openrouterBalance.value = await api.getOpenrouterBalance()
    } catch {}
    try {
      messengerWs.connect()
      messengerWs.subscribeToType('llm_billing_blocked', async (evt: any) => {
        try {
          llmBillingStatus.value = evt?.data || evt
        } catch {}
        try {
          llmBillingStatus.value = await api.getLlmBillingStatus('openrouter')
        } catch {}
        try {
          openrouterBalance.value = await api.getOpenrouterBalance()
        } catch {}
      })
      messengerWs.subscribeToType('llm_billing_unblocked', async () => {
        try {
          llmBillingStatus.value = await api.getLlmBillingStatus('openrouter')
        } catch {
          llmBillingStatus.value = { is_blocked: false }
        }
        try {
          openrouterBalance.value = await api.getOpenrouterBalance()
        } catch {}
      })
    } catch {}

    // Best-effort: poll blocked materialize count (WS events for this are not implemented yet)
    try {
      await loadMaterializeBlockedCount()
      if (materializePollIntervalId !== null) {
        window.clearInterval(materializePollIntervalId)
        materializePollIntervalId = null
      }
      materializePollIntervalId = window.setInterval(() => {
        loadMaterializeBlockedCount()
      }, 60_000)
    } catch {}
  }
})

onUnmounted(() => {
  if (materializePollIntervalId !== null) {
    window.clearInterval(materializePollIntervalId)
    materializePollIntervalId = null
  }
})
</script>

<style scoped>
/* Исправление отступов для вложенных пунктов меню */
:deep(.v-list-group__items .v-list-item) {
  padding-inline-start: 16px !important;
}

/* Уменьшение отступа для иконок во вложенных пунктах */
:deep(.nested-menu-item .v-list-item__prepend) {
  margin-inline-end: 8px !important;
}

/* Обеспечение видимости текста */
:deep(.nested-menu-item) {
  min-width: 0;
}

:deep(.nested-menu-item .v-list-item-title) {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}
</style>
